import clsx from 'clsx'
import { Link } from './link'

function hasAuditTextUtility(className: React.ComponentPropsWithoutRef<'p'>['className']) {
  return (
    typeof className === 'string' &&
    /\btext-(body(?:-lg|-sm)?|caption|mono|display-[\w-]+)\b/.test(className)
  )
}

export function Text({ className, ...props }: React.ComponentPropsWithoutRef<'p'>) {
  const usesAuditTextUtility = hasAuditTextUtility(className)

  return (
    <p
      data-slot="text"
      {...props}
      className={clsx(
        'font-sans text-zinc-700 dark:text-zinc-200',
        !usesAuditTextUtility && 'text-base/6 sm:text-sm/6',
        className
      )}
    />
  )
}

export function TextLink({ className, ...props }: React.ComponentPropsWithoutRef<typeof Link>) {
  return (
    <Link
      {...props}
      className={clsx(
        'font-sans text-zinc-950 underline decoration-zinc-950/50 data-hover:decoration-zinc-950 dark:text-white dark:decoration-white/50 dark:data-hover:decoration-white',
        className
      )}
    />
  )
}

export function Strong({ className, ...props }: React.ComponentPropsWithoutRef<'strong'>) {
  return (
    <strong {...props} className={clsx('font-medium text-zinc-950 dark:text-white', className)} />
  )
}

export function Code({ className, ...props }: React.ComponentPropsWithoutRef<'code'>) {
  return (
    <code
      {...props}
      className={clsx(
        'rounded-sm border border-zinc-950/10 bg-zinc-950/2.5 px-0.5 font-sans text-sm font-medium text-zinc-950 sm:text-[0.8125rem] dark:border-white/20 dark:bg-white/5 dark:text-white',
        className
      )}
    />
  )
}
